import cookie from 'react-cookies'

const isToken = !!(cookie.load('USER-SESSION'))
const { token } = isToken ? cookie.load('USER-SESSION') : ''

export const fetchApi = (endpoint, options = {}) => {
  return fetch(endpoint, {
    ...options,
    headers: {
      Accept: 'application/json,',
      'Content-Type': 'application/json',
      'x-session-token': token,
    },
  })
}



// WEBPACK FOOTER //
// ./src/utils/fetchApi.js